export type Pref<T> = ReturnType<typeof pref<T>>;

export const pref = <T>(name: string, defaul: T, onChange?: (value: T) => void) => {
	const storageKey = "pref:" + name;

	const set = localStorage.getItem(storageKey);
	// oxlint-disable-next-line typescript/no-unsafe-type-assertion
	const initial = set ? (JSON.parse(set) as T) : defaul;

	let state = $state.raw<T>(initial);
	onChange?.(initial);

	return {
		name,

		get value() {
			return state;
		},

		get isDefault() {
			return state == defaul;
		},

		set value(value: T) {
			state = value;

			if (value == defaul) {
				localStorage.removeItem(storageKey);
			} else {
				localStorage.setItem(storageKey, JSON.stringify(value));
			}

			onChange?.(value);
		},

		reset() {
			localStorage.removeItem(storageKey);

			state = defaul;
			onChange?.(state);
		},
	};
};
